export enum CardTypes {
  VISA = 'Visa',
  MASTERCARD = 'MasterCard',
  AMEX = 'AMEX',
  DISCOVER = 'Discover',
  DINERS_CLUB = 'DinersClub',
  JCB = 'JCB',
}

const MIN_CARD_NUMBER = 15;

class CardNumberService {
  cardLUHNCheckAlgorithm = (cardNumber: string | null): boolean => {
    if (!cardNumber || cardNumber?.length < MIN_CARD_NUMBER) return false;

    let checksum = 0;
    let j = 1;

    for (let i = cardNumber.length - 1; i >= 0; i -= 1) {
      let calc = 0;
      calc = Number(cardNumber.charAt(i)) * j;

      if (calc > 9) {
        checksum += 1;
        calc -= 10;
      }

      checksum += calc;

      if (j === 1) {
        j = 2;
      } else {
        j = 1;
      }
    }
    return (checksum % 10) === 0;
  };

  getCardType = (cc: string) => {
    // Regular expression to match American Express (AMEX) numbers:
    // - It starts with '3' followed by either '4' or '7'.
    // - Followed by exactly 13 more digits.
    const amex = new RegExp(/^3[47]\d{13}$/);

    // Regular expression to match Visa numbers:
    // - It starts with '4'.
    // - Followed by either 12 or 15 digits.
    const visa = new RegExp(/^4\d{12}(?:\d{3})?$/);

    // Regular expression to match Discover numbers:
    // - It starts with '6' followed by either '011' or '5' followed by a digit in the range of 0 to 9.
    // - Followed by exactly 12 more digits.
    const discover = new RegExp(/^6(?:011|5\d{2})\d{12}$/);

    // Regular expression to match Diners Club numbers:
    // - It starts with '3' followed by either '0' and a digit in the range of 0 to 5,
    //   OR starts with '6' or '8' followed by a digit.
    // - Followed by exactly 11 more digits.
    const diners = new RegExp(/^3(?:0[0-5]|[68]\d)\d{11}$/);

    // Regular expression to match JCB numbers:
    // - It starts with either '2131', '1800', or '35' followed by a digit in the range of 0 to 9.
    // - Followed by exactly 11 more digits.
    const jcb = new RegExp(/^(?:2131|1800|35\d{3})\d{11}$/);

  // Regular expression to match MasterCard numbers:
  // - Starts with '5' followed by a digit in the range of 1 to 5 (for standard MasterCard numbers),
  //   OR starts with '222' followed by a digit in the range of 1 to 9 (for specific MasterCard numbers),
  //   OR starts with '22' followed by a digit in the range of 3 to 9 (for specific MasterCard numbers),
  //   OR starts with '2' followed by a digit in the range of 3 to 6 (for specific MasterCard numbers),
  //   OR starts with '27' followed by a digit 0 or 1 (for specific MasterCard numbers),
  //   OR starts with '2720' followed by any digit (for specific MasterCard numbers).
  // - Followed by exactly 5 or more digits.
  const mastercard = new RegExp(/^(5[1-5]\d{5,}|22[2-9]\d{3,}|2[3-6]\d{5,}|27[01]\d{4,}|2720\d{3,})$/);
    if (visa.test(cc)) {
      return CardTypes.VISA;
    }
    if (amex.test(cc)) {
      return CardTypes.AMEX;
    }
    if (mastercard.test(cc)) {
      return CardTypes.MASTERCARD;
    }
    if (discover.test(cc)) {
      return CardTypes.DISCOVER;
    }
    if (diners.test(cc)) {
      return CardTypes.DINERS_CLUB;
    }
    if (jcb.test(cc)) {
      return CardTypes.JCB;
    }

    return '';
  };
}

export default new CardNumberService();